export interface ContentRecipient {
  id?: string | null;
  name?: string | null;
  eligible?: boolean | null;
}

export function recipientIds(recipients: ReadonlyArray<ContentRecipient | string> | null | undefined): string[] {
  return (recipients ?? []).map((group) => typeof group === "string" ? group : group.id)
    .filter((id): id is string => Boolean(id));
}

export function recipientRelations(recipients: ReadonlyArray<ContentRecipient | string> | null | undefined): Array<{ id: string }> {
  return recipientIds(recipients).map((id) => ({ id }));
}

export function sameRecipientIds(
  a: ReadonlyArray<ContentRecipient | string> | null | undefined,
  b: ReadonlyArray<ContentRecipient | string> | null | undefined,
): boolean {
  const left = [...new Set(recipientIds(a))].sort();
  const right = [...new Set(recipientIds(b))].sort();
  return left.length === right.length && left.every((id, i) => id === right[i]);
}
